/**
 * Randall's Refined Scripts — Accessibility Module
 * =================================================
 * Focus management, keyboard navigation, and a11y utilities.
 */

var RRS = window.RRS || {};

RRS.Accessibility = (function() {
  'use strict';

  /**
   * Focus Management
   * Distinguishes between mouse and keyboard users for focus styling
   */
  function initFocusManagement() {
    document.body.addEventListener('mousedown', function() {
      document.body.classList.add('using-mouse');
    });

    document.body.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        document.body.classList.remove('using-mouse');
      }
    });
  }

  /**
   * Skip Link Focus
   * Ensures skip-to-content link works properly
   */
  function initSkipLink() {
    var skipLink = document.querySelector('.skip-link');
    if (!skipLink) return;

    skipLink.addEventListener('click', function(e) {
      var targetId = skipLink.getAttribute('href');
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.focus();
        // Scroll into view
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /**
   * Trap Focus
   * Utility to trap focus within a container (for modals/dialogs)
   * @param {HTMLElement} container - The container to trap focus within
   * @param {KeyboardEvent} e - The keyboard event
   */
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;

    var focusable = container.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    if (focusable.length === 0) return;

    var firstFocusable = focusable[0];
    var lastFocusable = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === firstFocusable) {
      e.preventDefault();
      lastFocusable.focus();
    } else if (!e.shiftKey && document.activeElement === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  }

  /**
   * Announce to Screen Readers
   * Creates a live region announcement
   * @param {string} message - The message to announce
   * @param {string} priority - 'polite' or 'assertive'
   */
  function announce(message, priority) {
    priority = priority || 'polite';

    var announcer = document.getElementById('a11y-announcer');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'a11y-announcer';
      announcer.setAttribute('aria-live', priority);
      announcer.setAttribute('aria-atomic', 'true');
      announcer.className = 'visually-hidden';
      document.body.appendChild(announcer);
    }

    // Clear and set message (triggers announcement)
    announcer.textContent = '';
    setTimeout(function() {
      announcer.textContent = message;
    }, 100);
  }

  /**
   * Check Reduced Motion Preference
   * @returns {boolean}
   */
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Public API
   */
  return {
    init: function() {
      initFocusManagement();
      initSkipLink();
    },
    trapFocus: trapFocus,
    announce: announce,
    prefersReducedMotion: prefersReducedMotion
  };
})();
